import React, { createContext, useContext, useEffect, useState } from "react";
import translations from "./translations";

const STORAGE_KEY = "language";

const LanguageContext = createContext({
  lang: "en",
  t: translations.en,
  toggleLanguage: () => {},
});

const getInitialLanguage = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "es" ? "es" : "en";
  } catch (e) {
    return "en";
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLanguage);

  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      // Storage unavailable: the choice just won't survive a reload
    }
  }, [lang]);

  const toggleLanguage = () => setLang((prev) => (prev === "en" ? "es" : "en"));

  return (
    <LanguageContext.Provider
      value={{ lang, t: translations[lang], toggleLanguage }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
